import { createContext } from 'react';
const LayersContext = createContext(undefined);
export default LayersContext;
//# sourceMappingURL=LayersContext.js.map